import type { HTMLAttributes } from 'react';

type SurfaceElement = 'article' | 'div' | 'section';

export type SurfaceProps = HTMLAttributes<HTMLElement> & {
  as?: SurfaceElement;
  elevated?: boolean;
};

export const Surface = ({
  as: Component = 'div',
  className,
  elevated = false,
  ...props
}: SurfaceProps) => (
  <Component
    className={['hotam-surface', elevated ? 'hotam-surface--elevated' : '', className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  />
);
